import { render, staticRenderFns } from "./setNormalPrivilege.vue?vue&type=template&id=67db5707&scoped=true&"
import script from "./setNormalPrivilege.vue?vue&type=script&lang=js&"
export * from "./setNormalPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db5707",
  null
  
)

export default component.exports